import React from "react";
import Header from "../../Partials/Header/Header";
import axios from 'axios';
import moment from 'moment';
import Calendar from "../../Components/Calendar/Calendar";

import {
    Row,
    Container,
    Col,
    Card,
    CardText,
    CardBody,
    CardTitle
} from "reactstrap";
import Footer from "../../Partials/Footer/Footer";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faClock } from "@fortawesome/free-solid-svg-icons";
import "./Events.css";

library.add(faMapMarkerAlt, faClock);

export default class Events extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title: "Register to upcoming Events",
            modal: false,
            expand: false,
            events: {}
        };

        this.toggle = this.toggle.bind(this);

        this.compare = (a, b) => {
          if (moment(a.date).isSame(b.date, 'day')) {
            return moment(a.start_time).isBefore(b.start_time, 'minute') ? -1 : 1
          }
          return moment(a.date).isBefore(b.date, 'day') ? -1 : 1
        }
    }

    toggle(card) {
        if (this.state.expand === card) {
            this.setState({ expand: false });
        } else {
            this.setState({ expand: card });
        }
    }

    componentWillMount() {
        axios.get('/marketing-events')
            .then(response => {
                let results = response.data;
                this.setState({ events: results.sort((a, b) => this.compare(a, b)) });
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    render() {

        const listEvents = this.state.events && this.state.events.length > 0 ?
            this.state.events.map((event, i) =>
             
            <div className="col-md-4" key={i}>
                {moment().isBefore(event.date) ? 
                     <div className="hwb-box" >
               
                     <Col lg="11">
                         <img
                             src={require("../../img/mic.png")}
                             alt="integrator"
                             className="img-fluid hwb-img"
                         />
                         <Row>
                             <Card
                                 onClick={() => this.toggle("card_" + i)}
                                 className={this.state.expand === "card_" + i ? "active" : ""}
                             >
                                 <CardBody>
                                     <CardTitle>
                                         <p className="head">{event.title}</p>
                                         <p className="time"><FontAwesomeIcon className="oi" icon="clock" />{moment(event.start_time).format('HH:mm') + " - " + moment(event.end_time).format('HH:mm')}</p>
                                         <p className="venue"><FontAwesomeIcon className="oi" icon="map-marker-alt" />{event.venue}</p>
                                     </CardTitle>
                                     <CardText>
                                         {event.description}
                                         <span className="fadedReadmore" />
                                     </CardText>
                                 </CardBody>
                             </Card>
 
                             <a target="_blank" rel="noopener noreferrer" className="int-btn blue-btn d-block mx-auto" href={event.apply_url}>Register Now</a>
                         </Row>
                     </Col>
                 </div > :''}
               
                </div>

            ) : "";

        return (
            <div className="integrator-wrapper">
                <Header />
                <Container className="certificate-container">
                    <div className="register-events-block d-md-block">
                        <Calendar title={this.state.title} />
                        <div className="row">

                            {listEvents}

                        </div >
                    </div >
                </Container >
                <Footer />
            </div >
        );
    }
}